import { Button, SectionHeader } from "@pentabd/ui";
import { useTranslation } from "react-i18next";

import { STATUS } from "@constants/status.procurement";
import { DECISION_TYPE } from "@constants/workflow-decision-type";
import { ErrorModal, SuccessModal } from "@components";
import { useState } from "react";
import { executeWorkflow } from "@api/procurements/procurementWorkFlow";
import { useUser } from "@hooks/useUser";
import WorkFlowModal from "./WorkFlowModal";
import { useNavigate } from "react-router-dom";

const { APPROVE, APPROVED, REJECT, REJECTED } = DECISION_TYPE;

const { DRAFT, IN_PROGRESS } = STATUS;

export function PageHeader({
  changeActiveTab,
  procurement,
  procurementId,
}: {
  changeActiveTab: (arg: number) => void;
  procurement: any;
  procurementId: number | string;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUser();
  const { employeeMasterId } = user;
  const employeeID = Number(employeeMasterId);

  // modals
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);
  const [openWorkFlowModal, setOpenWorkFlowModal] = useState<boolean>(false);

  const createSuccessAction = () => {
    setIsSuccessModalOpen(false);
    navigate("/procurement");
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  const closeWorkFlowModal = () => {
    setOpenWorkFlowModal(false);
  };

  const handleWorkFlow = async (
    decisionType: string,
    nextFileOnHandId?: number,
    comments?: string,
  ) => {
    try {
      const res = await executeWorkflow(
        procurementId,
        decisionType,
        procurement?.processInstanceId,
        nextFileOnHandId,
      );
      setIsSuccessModalOpen(true);
    } catch (error) {
      setIsErrorModalOpen(true);
    }
  };

  return (
    <div>
      {/* Workflow modal */}

      <WorkFlowModal
        isOpen={openWorkFlowModal}
        closeWorkFlowModal={closeWorkFlowModal}
        procurementId={procurementId}
        processInstanceId={procurement?.processInstanceId}
        // nextFileOnHandPositionCode={procurement?.nextFileOnHandPositionCode}
        employeesForProcurementApprove={true}
      />

      {/* Workflow modal ends*/}
      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={createSuccessAction}
        />
      )}
      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}

      {/* modals end */}
      <SectionHeader
        title={t("PROCUREMENT_CREATE.TABS.FINAL_RECEIVING")}
        components={
          procurement?.status?.toUpperCase() === DRAFT
            ? [
                <Button
                  fill="fill"
                  type="danger"
                  onClick={() => setOpenWorkFlowModal(true)}
                >
                  {t("PROCUREMENT_CREATE.GENERAL_INFO.FORM.BUTTONS.SEND")}
                </Button>,
              ]
            : procurement?.status?.toUpperCase() === IN_PROGRESS &&
              employeeID === procurement?.fileOnHand?.id
            ? [
                <Button
                  fill="fill"
                  type="danger"
                  onClick={() => handleWorkFlow(REJECT, employeeID)}
                >
                  {t("PROCUREMENT_CREATE.GENERAL_INFO.FORM.BUTTONS.REJECT")}
                </Button>,
                <Button
                  fill="fill"
                  type="default"
                  className="bg-primary-lighter text-primary"
                  onClick={() => handleWorkFlow(APPROVE, employeeID)}
                >
                  {t(`PROCUREMENT_CREATE.GENERAL_INFO.FORM.BUTTONS.APPROVE`)}
                </Button>,
              ]
            : [<></>]
        }
      />
    </div>
  );
}
